import React from 'react';
import CustomerWeb from './components/customerweb/index';
import { BrowserRouter, Route, Switch} from 'react-router-dom';

import TagManager from 'react-gtm-module'

//Redux 
import {bindActionCreators} from 'redux';
import {connect, Provider} from 'react-redux';

//redux store
import store from './components/redux/store';

//redux action
import * as searchAction from './components/redux/action';

import IndexWeb from './components/indexWeb';
import withManagerWeb from './components/managerweb/withManagerweb';
import ManagerMain from './components/managerweb/managerMain';
import ManagerGeneralSetting from './components/managerweb/managerGeneralSetting';
import ManagerTemplate1 from './components/managerweb/managerTemplate1/managerTemplate1';
import ManagerTemplate2 from './components/managerweb/managerTemplate2/managerTemplate2';
import ManagerTemplate3 from './components/managerweb/managerTemplate3/managerTemplate3';
import ManagerTemplate4 from './components/managerweb/managerTemplate4/managerTemplate4';
import ManagerTemplate5 from './components/managerweb/managerTemplate5/managerTemplate5';
import ManagerTemplate6 from './components/managerweb/managerTemplate6/managerTemplate6';
import ManagerLogining from './components/managerweb/managerLogining';
import ManagerLogin from './components/managerweb/managerLogin';
import imageGallery from './components/managerweb/managerPictures';
import imageGallery2 from './components/managerweb/managerPicturesCenter';
//add 20201223
import ManagerCheckIp from './components/managerweb/managerIpCheck';
//add 20201216 Loader
//import LazyLoad from './components/sharecomponents/Loader';
import './App.css';


//redux State
const mapStateToProps = (state) => {
  //console.log('mapStateToProps-state'+JSON.stringify(state))
    return {
      ...state
    }
  }

//redux Dispatch
const mapDispatchToProps = (dispatch) => {
 // console.log('mapDispatchToProps-dispatch')
    return{
          ...bindActionCreators(searchAction,dispatch)
    }
}



const tagManagerArgs = {
  gtmId: 'GTM-TCHT6C6'
}

TagManager.initialize(tagManagerArgs)

const WithManagerMain = withManagerWeb(connect(mapStateToProps, mapDispatchToProps)(ManagerMain));
const WithGerneralSetting = withManagerWeb(connect(mapStateToProps, mapDispatchToProps)(ManagerGeneralSetting));
const WithManagerTemplate1 = withManagerWeb(connect(mapStateToProps, mapDispatchToProps)(ManagerTemplate1));
const WithManagerTemplate2 = withManagerWeb(connect(mapStateToProps, mapDispatchToProps)(ManagerTemplate2));
const WithManagerTemplate3 = withManagerWeb(connect(mapStateToProps, mapDispatchToProps)(ManagerTemplate3));
const WithManagerTemplate4 = withManagerWeb(connect(mapStateToProps, mapDispatchToProps)(ManagerTemplate4));
const WithManagerTemplate5 = withManagerWeb(connect(mapStateToProps, mapDispatchToProps)(ManagerTemplate5));
const WithManagerTemplate6 = withManagerWeb(connect(mapStateToProps, mapDispatchToProps)(ManagerTemplate6));
const WithImageGallery = withManagerWeb(imageGallery);
const WithImageGallery2 = withManagerWeb(imageGallery2);
const ConnectCustomerWeb = connect(mapStateToProps, mapDispatchToProps)(CustomerWeb);

//關閉lazy寫法 因為也無法解決某區塊消失或異常
// const CustomerWeb=React.lazy(()=>import('./components/customerweb/index'));
// const ConnectCustomerWeb = connect(mapStateToProps, mapDispatchToProps)(CustomerWeb);
// const LazyConnectCustomerWeb =(props)=><LazyLoad component={ConnectCustomerWeb} {...props} />


/* 
function auth() {

  axios.post('http://myweburl.org/app/web/checkLogin', { headers: {'Accept': 'application/json'} })
    .then((response) => {
      console.log(response);
      if(response.data.success){
        return true;
      }else if(response.data.error){
        return false;
      }
    });

};

const isAuthorized = auth(); */

/*
add 2020-12-18 Route path="/web/preview/:cid" 給求職那邊專屬預覽頁面
*/
function App() {
  return (
      <div className="App">
         
         <Provider store={store}>
            <BrowserRouter>
              <Switch>
                  <Route exact path="/" component={IndexWeb} />
                  <Route exact path="/login/" component={ManagerLogining} />
                  <Route exact path="/CSLogin/" component={ManagerLogin} />
                  <Route exact path="/:cid" component={ConnectCustomerWeb} />
                  <Route exact path="/managerweb/:cid/" component={WithGerneralSetting} />
                  <Route exact path="/managerweb/:cid/setting" component={WithGerneralSetting} />
                  <Route exact path="/managerweb/:cid/help/" component={WithManagerMain} />
                  <Route exact path="/managerweb/:cid/template1" component={WithManagerTemplate1} />
                  <Route exact path="/managerweb/:cid/template2" component={WithManagerTemplate2} />
                  <Route exact path="/managerweb/:cid/template3" component={WithManagerTemplate3} />
                  <Route exact path="/managerweb/:cid/template4" component={WithManagerTemplate4} />
                  <Route exact path="/managerweb/:cid/template5" component={WithManagerTemplate5} />
                  <Route exact path="/managerweb/:cid/template6" component={WithManagerTemplate6} />
                  <Route exact path="/managerweb/:cid/preview/:themNum" component={ConnectCustomerWeb} />
                  <Route exact path="/managerweb/:cid/imageGallery" component={WithImageGallery} />
                  <Route exact path="/managerweb/:cid/imageGallery2" component={WithImageGallery2} />                   
                  <Route exact path="/:cid/:enName" component={ConnectCustomerWeb} />
                  <Route exact path="/web/preview/:cid" component={ConnectCustomerWeb} />
                  <Route exact path="/web/preview/Ip/Check" component={ManagerCheckIp} />
              </Switch>
             </BrowserRouter>
        </Provider>

      </div>
  );
}

export default App;
